import React, { Component } from 'react'
import './index.scss'
import { SetIsShowLoginDialog } from '../../../Interface'
import { connect } from 'react-redux'

import { Trans } from 'react-i18next'
import i18n from '../../../i18n'

class CompareArea extends Component {

    handleClickButton = () => {
        // 이우섭 0513
        // React에서 제공하는 ref 방식으로 다른 컴포넌트를 접근하려니 코드라인이 너무 복잡해짐.
        // javascript로 직접 접근.
        const els = document.getElementsByClassName('gallery-area-en-root-container')
        if (els.length >= 1) {
            els[0].scrollIntoView({ behavior: "smooth" })
        }
    }

    render() {
        const { currentUser } = this.props

        return (
            <div className='compare-area-root-container'>
                <div className='compare-area-body'>
                    <div className='left-area'>
                        <div className='title'>
                            <Trans i18nKey="web.newhome.compare.title">
                                <br />
                                <span />
                            </Trans>
                        </div>
                        <div className='subtitle'>{i18n.t("web.newhome.compare.subtitle")}</div>
                        <div className='des'>
                            <Trans i18nKey="web.newhome.compare.des">
                                <br />
                            </Trans>
                        </div>
                        <div className='setting-btn' onClick={this.handleClickButton} >{i18n.t("web.newhome.compare.button")}</div>
                    </div>
                    <div className='right-area'>
                        <div className='video-area'>
                            <div className='compare-text'>Videomonster</div>
                            <video src="https://videomonsterpublic.blob.core.windows.net/00websitefile/videos/home/en_landing_compare.mp4" muted autoPlay loop />
                            <div className='compare-text other'>{i18n.t("web.newhome.compare.other")}</div>
                        </div>
                        <div className='vs'>VS</div>
                    </div>
                </div>
            </div >
        )
    }
}

const mapStateToProps = state => ({
    currentUser: state.userStore.user,
})

export default connect(mapStateToProps, null)(CompareArea)